export function NavbarSurface() {
  return (
    <svg
      aria-hidden
      className='pointer-events-none absolute inset-0 h-full w-full overflow-hidden'
    >
      <rect
        x='0'
        y='0'
        width='100%'
        height='100%'
        rx='15'
        ry='15'
        fill='var(--color-black-800)'
      />
      <rect
        x='0'
        y='0'
        width='100%'
        height='100%'
        rx='15'
        ry='15'
        fill='url(#navbar-surface-radial)'
        fillOpacity='0.2'
      />
      <rect
        x='1'
        y='1'
        width='calc(100% - 2px)'
        height='calc(100% - 2px)'
        rx='14'
        ry='14'
        fill='none'
        stroke='url(#navbar-surface-stroke)'
        strokeWidth='2'
      />
      <defs>
        <radialGradient
          id='navbar-surface-radial'
          cx='0.5'
          cy='1.06'
          r='0.8'
          gradientUnits='objectBoundingBox'
        >
          <stop stopColor='white' stopOpacity='0.55' />
          <stop offset='0.370192' stopColor='white' stopOpacity='0.25' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </radialGradient>
        <linearGradient
          id='navbar-surface-stroke'
          x1='0'
          y1='0'
          x2='0'
          y2='1'
          gradientUnits='objectBoundingBox'
        >
          <stop stopColor='white' stopOpacity='0.02' />
          <stop offset='1' stopColor='white' stopOpacity='0.05' />
        </linearGradient>
      </defs>
    </svg>
  )
}
